import { useState, useCallback } from 'react';

import { usePublicationUnavailableListener } from '../../../../../../../../../hooks/usePublicationUnavailableListener';

interface IResult {
  isAnimated: boolean;
}

export const useAnimation = (): IResult => {
  const [isAnimated, setIsAnimated] = useState(false);
  const animate = useCallback(() => {
    setIsAnimated(true);

    setTimeout(() => setIsAnimated(false), 400);
  }, []);

  usePublicationUnavailableListener(animate);

  return { isAnimated };
};
